import { Injectable } from '@angular/core'
import { SeFeTranslationsLoader } from 'se-fe-translations'

@Injectable()
export class RegistrationCardTranslationsService {
  private static translationsLoadPromise?: Promise<boolean>
  private readonly translationsPath = 'se-registration/ui-registration-card/assets/translations'

  constructor(private translationsLoader: SeFeTranslationsLoader) {}

  public load(): Promise<boolean> {
    if (!RegistrationCardTranslationsService.translationsLoadPromise) {
      RegistrationCardTranslationsService.translationsLoadPromise = this.translationsLoader
        .load(this.translationsPath)
        .then(loaded => {
          if (!loaded) RegistrationCardTranslationsService.translationsLoadPromise = undefined
          return loaded
        })
        .catch(err => {
          RegistrationCardTranslationsService.translationsLoadPromise = undefined
          throw err
        })
    }

    return RegistrationCardTranslationsService.translationsLoadPromise
  }
}
